export default {
  app_title: 'Yapzek',
  app_version: __COMFYUI_FRONTEND_VERSION__
}
